module.exports = __webpack_public_path__ + "a1ccd993c01b11e9b68bc0ba3de3e8a5.png";